import { css } from 'styled-components'
import { ButtonPrimaryCSS } from 'components/elements/Buttons/ButtonPrimary'
import { ButtonSecondaryCSS } from 'components/elements/Buttons/ButtonSecondary'

export const FormCSS = css`
  position: relative;

  & .form-duuf-group {
    position: relative;
    margin-bottom: 2rem;
  }

  & .form-duuf-textarea,
  & .form-duuf-input {
    width: 100%;
    border-color: hsl(0, 0%, 80%);
    border-radius: 100px;
    border-style: solid;
    border-width: 1px;
    min-height: 38px;
    padding-left: 0.75rem;

    @media (min-width: 992px) {
      max-width: 400px;
    }
  }

  & .form-duuf-textarea {
    height: 186px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 25px !important;
  }

  & .form-duuf-file-button {
    ${ButtonSecondaryCSS};
  }

  & .form-duuf-file-name {
    margin-left: 0.5rem;
  }

  & .form-duuf-label {
    padding-bottom: 0.25rem;
    padding-left: 0.75rem;
  }

  & .form-duuf-checkbox-label {
    margin-left: 1.5rem;
    margin-bottom: 0;
  }

  & .form-duuf-label-mandatory {
    color: ${({ theme }) => theme.color.secondary};
  }

  & .form-duuf-error {
    position: absolute;
    top: 0;
    color: tomato;

    @media (min-width: 1200px) {
      right: 125px;
    }

    @media (max-width: 1199.98px) {
      right: 0;
    }
  }

  & .form-duuf-group-submit {
    text-align: center;
  }

  & .form-duuf-submit {
    ${ButtonPrimaryCSS};

    &-disabled {
      opacity: 0.5;
    }
  }

  & .form-duuf-confirm {
    & .gform_confirmation_message {
      font-size: 20px !important;
      text-align: center;
    }
  }

  & .form-duuf-something-wrong {
    color: red;
  }

  & .form-duuf-loading {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .form-duuf-group-consent {
    position: relative;

    & a {
      text-decoration: underline;
    }

    & div.d-flex {
      align-items: flex-start !important;

      & > input {
        margin-top: 5px;
        margin-right: 5px;
      }
    }

    & .form-duuf-error-consent {
      position: absolute;
      right: 0;

      @media (min-width: 1200px) {
        top: -20px;
      }

      @media (max-width: 1199.98px) {
        top: unset;
        bottom: -50px;
      }
    }

    @media (max-width: 1199.98px) {
      margin-bottom: 4rem;
    }
  }
`
